export const contact = [
    {
        icon: "icon-[tabler--brand-mailgun]",
        label: "Email",
        link: "mailto:hello@johannahendrix.com",
    },
];
